var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import logo from "./logo.svg";
var App = function () {
    return (_jsxs("div", __assign({ className: "App" }, { children: [_jsxs("h1", __assign({ className: "App-header" }, { children: ["React w/ Typescript App Builder (", process.env.NODE_ENV, ")"] })), _jsx("img", { src: logo, alt: "react-typescript", className: "App-logo", width: "500px" }), _jsxs("p", __assign({ className: "App-info" }, { children: ["Start editing files in ", _jsx("strong", { children: "src" }), " folder to actually", " ", _jsx("em", { children: "START !!" })] }))] })));
};
export default App;
